import React from 'react';
import { PropTypes } from 'prop-types';
import Pagination from 'react-js-pagination';

const SearchPager = ({
  page,
  totalEntries,
  setPage,
  perPage,
  prevPageText,
  nextPageText,
  firstPageText,
  lastPageText
}) => (
  <Pagination
    innerClass="rc-pager"
    activePage={page}
    itemsCountPerPage={perPage}
    totalItemsCount={totalEntries}
    onChange={setPage}
    prevPageText={prevPageText}
    nextPageText={nextPageText}
    firstPageText={firstPageText}
    lastPageText={lastPageText}
  />
);

SearchPager.propTypes = {
  page: PropTypes.number,
  totalEntries: PropTypes.number,
  setPage: PropTypes.func,
  perPage: PropTypes.number,
  prevPageText: PropTypes.string,
  nextPageText: PropTypes.string,
  firstPageText: PropTypes.node,
  lastPageText: PropTypes.node
};

export default SearchPager;
